var Flow = /*@__PURE__*/ (function () {
    function Flow(roamingStepper, state) {
        var _this = this;
        this.getRoamingStepper = function () {
            return _this.roamingStepper;
        };
        this.setRoamingStepperItem = function (index) {
            _this.roamingStepperItem = index;
            _this.element = _this.roamingStepper.getItem(index).getElement();
        };
        this.getState = function () {
            return _this.state.getState();
        };
        this.setState = function (newState) {
            _this.state.setState(newState);
        };
        this.activate = function () {
            _this.roamingStepper.setActive(_this.roamingStepperItem);
        };
        this.getElement = function () {
            return _this.element;
        };
        this.enableNextButton = function () {
            jQuery(_this.getElement())
                .find('.next-step')
                .removeClass('disabled')
                .off('click')
                .prop('disabled', false);
            _this.bindEventListeners();
        };
        this.disableNextButton = function () {
            jQuery(_this.getElement())
                .find('.next-step')
                .addClass('disabled')
                .prop('disabled', true);
        };
        this.bindEventListeners = function () {
            jQuery(_this.getElement())
                .find('.next-step')
                .on('click', function () {
                _this.onNextRequest();
            });
        };
        this.getItem = function () {
            return _this.roamingStepper.getItem(_this.roamingStepperItem);
        };
        this.roamingStepper = roamingStepper;
        this.state = state;
        window.vf._memory = window.vf._memory || {};
        window.vf._memory.appointmanFlowWatchers = window.vf._memory.appointmanFlowWatchers || [];
        window.vf._memory.appointmanFlowWatchers.push(function () {
            _this.onStateChange();
        });
        this.bindEventListeners();
    }
    return Flow;
}());
export default Flow;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/flow/Flow.ts
// module id = null
// module chunks = 